import {useEffect} from "react";
import {create} from "zustand";
import {toMs} from "@cdx/shared/duration";
import cdxEnv from "../env";
import {getRequest} from "../lib/request";

const useDeploymentStore = create(() => ({
  replacedAt: null,
}));

const INTERVAL = toMs.hours(2);

const checkInfo = (opts = {}) => {
  const {APP_NAME, DEPLOYMENT_LABEL} = cdxEnv;
  if (!APP_NAME || !DEPLOYMENT_LABEL) return;
  opts.timeoutId = setTimeout(
    () => {
      getRequest("/services/deployment-info", {appName: APP_NAME, label: DEPLOYMENT_LABEL}).then(
        (body) => {
          const {replacedAt} = body || {};
          useDeploymentStore.setState({replacedAt: replacedAt ? new Date(replacedAt) : null});
          checkInfo(opts);
        },
        () => checkInfo(opts)
      );
    },
    INTERVAL * (0.75 + Math.random() * 0.5)
  );
  return () => clearTimeout(opts.timeoutId);
};

export const DeploymentInfo = () => {
  useEffect(() => checkInfo(), []);
  return null;
};

export const OLD_RELEASE_MS = toMs.days(7);

export const useDeploymentAgeInMs = () => {
  const replacedAt = useDeploymentStore((s) => s.replacedAt);
  return replacedAt ? new Date().getTime() - replacedAt.getTime() : null;
};
